import { type CSSProperties, Fragment, type HTMLAttributes } from "react";
import { ColoredLabel, TruncateList } from "widgets";

import css from "../styles/Cell.module.css";

// 10px bullet + 1px border on each side + 5px column gap from ColoredLabel.module.css.
const COLORED_LABEL_EXTRA_WIDTH = 17;

export interface TruncateColoredLabelListItem {
  key: string;
  label: string;
  color: CSSProperties["backgroundColor"];
}

export interface TruncateColoredLabelListProps {
  items: readonly TruncateColoredLabelListItem[];
  separator?: string;
  ellipsis?: string;
  className?: string;
  style?: CSSProperties;
}

export function TruncateColoredLabelList({
  items,
  separator = ", ",
  ellipsis = "…",
  className,
  style,
  ...props
}: TruncateColoredLabelListProps & HTMLAttributes<HTMLSpanElement>) {
  return (
    <TruncateList
      items={items}
      getLabel={(item) => item.label}
      separator={separator}
      ellipsis={ellipsis}
      extraWidthPerVisibleItem={COLORED_LABEL_EXTRA_WIDTH}
      className={className}
      style={style}
      {...props}
    >
      {({ hiddenCount, resultText, separator: computedSeparator, suffixText, visibleItems, visibleLabels }) => {
        if (visibleItems.length === 0) {
          return resultText;
        }

        return (
          <>
            {visibleItems.map((item, index) => (
              <Fragment key={item.key}>
                <ColoredLabel color={item.color} label={visibleLabels[index]} />
                {index < visibleItems.length - 1 && computedSeparator}
              </Fragment>
            ))}
            {hiddenCount > 0 && <span className={css.affix}>{suffixText}</span>}
          </>
        );
      }}
    </TruncateList>
  );
}
